<template>
  <div>
    <div class="row" v-if="editing">
      <div class="col-4">
        <label for="">{{ $t('insights.ui.timespan.label') }}</label>
        <select name="" class=form-control v-model="config.weekDifference" id="">
          <option :value="-1">{{ $t('insights.ui.timespan.lastWeek') }}</option>
          <option :value="0">{{ $t('insights.ui.timespan.currentWeek') }}</option>
        </select>
      </div>
      <div class="col-3">
        <label for="title-planning">{{ $t('ui.title') }}</label>
        <input type="text" id="title-planning" class="form-control" v-model="config.title">
      </div>
      <div class="col-xs-3">
        <label for="filter-on">Filter</label>
        <select name="" class="form-control" v-model="config.filterByKey" id="">
          <option :value="key" :key="key" v-for="key in getUniqueKeys">{{ getFormattedKey(key) }}</option>
        </select>
      </div>
    </div>

      <template v-if="!editing">
         <label for="filter-value"> Filter </label>
        <select name="filter-value" class="form-control" v-if=config.filterByKey v-model="config.filterByValue" id="">
          <option
              :value="value" :key="value" v-for="value in getUniqueValues">{{ getFormattedValue(value) }}
          </option>
        </select>
      </template>
    <div class="chart-container "  >

      <line-chart style="width: 100%; height: 100%"
                  v-if="config.filterByValue != null"
                  :chartData="getChartData"
                  :options="getOptions"/>

    </div>


  </div>


</template>

<script>
import LineChart from '@/components/insights/charts/barChart.js'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";

export default {
  components: {
    LineChart
  },
  mixins: [timeCalc, generalMethods, chartColors],
  props: ['editing'],
  data() {
    return {
      jobs: [],
      config: {
        weekDifference: 0,
        filterByKey: null,
        filterByValue: null,
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    ...mapGetters('workflows', ['getWorkflowName']),
    getJobs() {
      return this.jobs
    },
    getOptions() {
      const self = this
      return {
        ...this.generalChartOptions,
        scales: {

          offset: true, // IF this is set to false, it will not display the last bar!
          xAxes: [
            {
              gridLines: {
                display: false
              },
              stacked: true,
              offset: true, // IF this i
              type: 'time',
              time: {
                unit: 'day',
                round: 'day',
                time: {
                  displayFormats: {
                    quarter: 'DD MM'
                  }
                }
              }
            },
          ],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              stepSize: ((1000 * 60 * 60)) * 5,
              callback: function (label, index, labels) {
                if (label === 0) {
                  return 0
                }
                if (label > 1000 * 60 * 60) {
                  return self.getHoursFromMilliseconds(label, false) + ' hour(s)'
                } else {
                  return self.formattedColonTime(label, false)
                }
              }
            }
          }],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return moment(tooltip[0].label).format('MMM DD')
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.value)     //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex >   0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0    ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    },
    getUniqueKeys() {
      return this.getUniqueJobKeys()
    },
    getUniqueValues() {
      // should loop and get values if type
      let mappedValues = _.map(this.jobs, (job) => {
        if (job[this.config.filterByKey] && job[this.config.filterByKey].length && typeof job[this.config.filterByKey] == "object") {
          return _.uniq(job[this.config.filterByKey])
        }
        return job[this.config.filterByKey]
      })
      let res = _.flattenDeep(mappedValues).filter(val => {
        return val
      })
       return [...new Set(res)].sort();

    },

    calculatedTarget() {
      const plannedTarget = _.chain(this.getJobsGrouppedOnPlannedDate).map((job, id) => ({
        date: id,
        t: id,
        y: _.sumBy(job, j => {
          return !j.finishedDate ? j.target : 0
        }),
        target: _.sumBy(job, 'target'),
        count: job.length,

      })).value()

      const plannedTimeSpentFinishedUnderTarget = _.chain(this.getJobsGrouppedOnPlannedDate).map((job, id) => ({
        date: id,
        t: id,
        y: _.sumBy(job, (j) => {
          let timeSpent = j.timeSpent ? j.timeSpent : 0
          let downTimePlanned = j.downTimeTotalPlanned ? j.downTimeTotalPlanned : 0
          let actual = timeSpent - downTimePlanned
          return actual < j.target ? actual : j.target
        }),
      })).value()
      const plannedTimeSpentFinishedOverTarget = _.chain(this.getJobsGrouppedOnPlannedDate).map((job, id) => ({
        date: id,
        t: id,
        y: _.sumBy(job, (j) => {
          let timeSpent = j.timeSpent ? j.timeSpent : 0
          let downTimePlanned = j.downTimeTotalPlanned ? j.downTimeTotalPlanned : 0
          let actual = timeSpent - downTimePlanned
          return actual > j.target ? actual - j.target : 0
        }),
      }))
          .value()
      return [plannedTarget, plannedTimeSpentFinishedUnderTarget, plannedTimeSpentFinishedOverTarget]

    },
    getJobsGrouppedOnPlannedDate() {
      let filtered = _.filter(this.getJobs, job => {
        return job[this.config.filterByKey] == this.config.filterByValue
      })
      return _.groupBy(filtered, (job) => {
        return job.plannedDate.toDate()
      })
    },
    getChartData() {
      return {
        labels: [],
        datasets: [
          {
            label: 'Planned Target',
            backgroundColor: this.colors.planning.target,
            data: this.calculatedTarget[0] ? this.calculatedTarget[0] : [0],
            stack: 'Stack 0',

          },
          {
            stack: 'Stack 1',
            label: 'timeSpent',
            backgroundColor: this.colors.planning.timeSpent,
            data: this.calculatedTarget[1] ? this.calculatedTarget[1] : [0]
          },
          {
            stack: 'Stack 1',
            label: 'Target overTime',
            backgroundColor: this.colors.planning.overTime,
            data: this.calculatedTarget[2] ? this.calculatedTarget[2] : [0]
          }
        ]
      }
    },
  },


  methods: {
    async getJobsFromFilter() {
      let userClaims = this.getClaims

      let time = moment().startOf('week').add(parseInt(this.config.weekDifference), 'week')
       try {
        let jobs = (await this.$FBClient.firestore().collection('jobs')
            .where('companyId', '==', userClaims.companyId)
            .where('plannedDate', '>=', time.toDate())
            .where('plannedDate', '<=', time.endOf('week').toDate())
            .get()).docs.map(doc => {
          return doc.data()
        })
        this.jobs = jobs
      } catch {
      }
      return false
    },

  },
  watch: {
    'config.weekDifference'() {
      this.getJobsFromFilter()
    }
  },
  created() {

  },
  async mounted() {
    await this.getJobsFromFilter()
  },
}
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";
</style>